import { Component, OnInit, ChangeDetectorRef, ViewChild, ChangeDetectionStrategy, OnDestroy, NgZone } from '@angular/core';
import { ActionSheetController, ToastController, AlertController, IonContent, NavController, ModalController, PopoverController, Platform } from '@ionic/angular';
import { AuftragService } from 'src/app/api/auftrag.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { Auftragsstatus } from 'src/app/api/model/aufteagsstatus';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { WebView } from '@awesome-cordova-plugins/ionic-webview/ngx';
import { ActionSheetButton } from '@ionic/core';

// https://stackoverflow.com/questions/38080654/ionic-2-angular-2-images-prepended-with-unsafe-therefore-not-displaying-ev
import { DomSanitizer } from '@angular/platform-browser';
import { MyApp } from 'src/app/api/helper/app';
import { StammdatenService } from 'src/app/api/stammdaten.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Auftragstyp } from 'src/app/api/model/swagger-model';
import { AppConfig } from 'src/app/api/helper/app.config';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { Utils } from 'src/app/api/helper/utils';
import { LieferungComponent } from 'src/app/shared/components/lieferung/lieferung.component';
import { Auftragdetails } from './auftragdetails.helper';
import { AuftragMenuPopoverComponent } from './popovers/auftrag-menu-popover.component';
import { AuftragsdateilsDarstellung } from 'src/app/api/model/model';

const log = new Logger("AuftragdetailsComponent");

@Component({
    selector: 'app-auftragdetails',
    templateUrl: './auftragdetails.component.html',
    styleUrls: ['./auftragdetails.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragdetailsComponent implements OnInit, OnDestroy {
    @ViewChild('content', { static: false }) content: IonContent;
    @ViewChild('appLieferung', { read: LieferungComponent, static: false }) appLieferung: LieferungComponent;

    auftragdetails: Auftragdetails;

    app = MyApp.current;
    key: string = null;
    auftragsnummer: any;
    darstellung: AuftragsdateilsDarstellung = 'standard';
    unterMandant = '';
    geladen = false;
    isDestroyed = false;
    isVisible = false;
    initialisiert = false;
    isKommissionierung = false;
    subscriptions: Subscription[] = [];
    statuszusatzinfoModal: HTMLIonModalElement;
    isModalSichtbar = false;

    navigation = true;
    fotos = true;
    lieferungAnzeigen = true;

    menuButtonVisible = AppConfig.current.einstellungen.MenueAuftragdetailsAnzeigen === 'ja';

    constructor(
        private platform: Platform,
        private auftragService: AuftragService,
        private stammdatenService: StammdatenService,
        private router: Router,
        public domSanitizationService: DomSanitizer,
        private modalController: ModalController,
        private cdr: ChangeDetectorRef,
        private file: File,
        private ngZone: NgZone,
        private fileOpener: FileOpener,
        private toastController: ToastController,
        private actionSheetController: ActionSheetController,
        private popoverController: PopoverController,
        private alertController: AlertController,
        private webView: WebView,
        private route: ActivatedRoute,
        private nav: NavController) {

        this.auftragdetails = new Auftragdetails(
            this.webView,
            this.toastController,
            this.router,
            this.modalController,
            this.actionSheetController,
            this.file,
            this.fileOpener,
            this.alertController,
            this.stammdatenService
        );
    }

    get auftrag() { return this.auftragdetails?.auftrag; };
    get workflow() { return this.auftragdetails.workflow; };
    get formularKonfiguration() { return this.auftragdetails.formularKonfiguration; };
    get checklisten() { return this.auftragdetails.checklisten; };
    get auftragsbilder() { return this.auftragdetails.auftragsbilder; };
    get bilder() { return this.auftragdetails.bilder; };
    get buttons() { return this.auftragdetails.buttons; };
    get buttons2() { return this.auftragdetails.buttons2; };
    get buttons3() { return this.auftragdetails.buttons3; };

    async ngOnInit() {
        log?.debug('ngOnInit');

        try {
            const auftragsKey = this.route.snapshot.paramMap.get('auftragsKey');

            log?.info('AUFTRAGDETAILS ' + auftragsKey);

            if (this.auftragdetails.auftrag && this.auftragdetails.auftrag.Key == auftragsKey && this.geladen) {
                // View bereits geladen. nicht neu laden
                return;
            }

            this.isDestroyed = false;
            this.geladen = false;
            this.initialisiert = false;

            if (this.route.snapshot.data) {
                this.darstellung = this.route.snapshot.data.darstellung;
            }

            this.auftragdetails.auftrag = await this.auftragService.getAuftrag(auftragsKey);

            // log?.debug('auftrag', this.auftragdetails.auftrag);

            if (this.auftrag == null) {
                UiHelper.showError('Auftrag nicht gefunden: ' + auftragsKey);
                this.goBack();
                return;
            }

            if (this.auftrag.Auftragstyp === Auftragstyp.Transportauftrag) {
                this.darstellung = AppConfig.current.einstellungen.TransportauftragDarstellung;
            } else if (this.auftrag.Auftragstyp === Auftragstyp.Hofchecker) {
                // this.darstellung = 'standard';
            } else if (this.auftrag.Auftragstyp === Auftragstyp.Kommissionierung) {
                // TODO: Kommen wir aus der Beladung?
                if (!this.darstellung) {
                    this.darstellung = 'kommissionierung';
                }

            } else if (this.auftrag.Auftragstyp === Auftragstyp.Wareneingang) {
                this.darstellung = 'wareneingang';
            }

            if (this.darstellung === 'wizard') {
                this.auftragdetails.updateAuftragAbgeschlossen();

                if (this.auftragdetails.istAuftragAbgeschlossen) {
                    this.darstellung = 'standard';
                }
            }

            if (!this.darstellung) {
                this.darstellung = 'standard';
            }

            this.unterMandant = '';

            if (this.auftrag.UnterMandant) {
                if (AppConfig.current.UnterMandant) {
                    if (this.auftrag.UnterMandant.trim().toUpperCase() !== AppConfig.current.UnterMandant.trim().toUpperCase()) {
                        // Es handelt sich um einen Auftrag von einem anderen Untermandanten als das Gerät zugeordnet ist
                        this.unterMandant = this.auftrag.UnterMandant;
                    }
                }
            }

            this.auftragService.setzeAktivenAuftrag(this.auftrag, 'auftragdetails');

            this.auftragsnummer = this.auftrag.Auftragsnummer;

            this.auftragdetails.darstellung = this.darstellung;
            this.auftragdetails.workflow = await this.stammdatenService.getWorkflow(this.auftrag.WorkflowName);
            this.auftragdetails.formularKonfiguration = await this.stammdatenService.getAuftragsFormularKonfiguration(this.auftrag, this.darstellung);

            if (this.workflow.fallback) {
                UiHelper.showAlert(`Achtung: Workflow '${this.auftrag.WorkflowName}' nicht konfiguriert. Bitte benachrichtigen Sie Ihren Administrator.`);
            }

            this.navigation = this.workflow.einstellungen.Navigation !== 'nein';
            this.fotos = this.workflow.einstellungen.Fotos === 'ja';
            this.lieferungAnzeigen = this.workflow.einstellungen.LieferungAnzeigen === 'ja';

            await this.auftragdetails.init();

            this.geladen = true;

            this.subscriptions.push(this.auftragService.auftragGeloescht.subscribe((geloeschterAuftrag) => {
                log?.debug('auftragGeloescht: ' + geloeschterAuftrag?.Key);

                if (this.auftrag && this.auftrag.Key == geloeschterAuftrag.Key) {
                    this.ngZone.run(() => {
                        if (!geloeschterAuftrag.loeschMeldungWurdeAngezeigt) {
                            // Gelöscht-Meldung wurde noch nicht angezeigt.
                            UiHelper.showAlert(`Auftrag ${this.auftrag.Auftragsnummer} wurde gelöscht`);
                        }

                        this.nav.navigateRoot('/');
                    });
                }
            }));

            if (this.auftrag.Auftragstyp == Auftragstyp.Transportauftrag) {
                if (AppConfig.current.einstellungen.TransportauftragFahrzeugKennzeichenPruefen == 'oeffnen') {
                    // Prüfe ob das Kennzeichen zum angemeldeten Fahrzeug passt
                    if (this.auftrag.FahrzeugKennung && this.auftrag.Auftragsstatus < Auftragsstatus.InBearbeitung) {
                        const fahrzeugKennzeichen = Utils.trimToEmpty(MyApp.current.getFahrzeugKennzeichen());

                        if (fahrzeugKennzeichen) {
                            if (fahrzeugKennzeichen != this.auftrag.FahrzeugKennung) {
                                UiHelper.showAlert(`Auftrag ist geplant für Fahrzeug \n${this.auftrag.FahrzeugKennung}.\nTour wurde mit Fahrzeug \n${fahrzeugKennzeichen} \ngestartet.`, 'Achtung');
                            }
                        }
                    }
                }
            }

            if (MyApp.isCordovaAvailable()) {
                this.subscriptions.push(this.platform.resume.subscribe(() => this.onResume()));
            }

            this.detectChanges('ngOnInit');

            this.initialisiert = true;
        } catch (err) {
            log.error('ngOnInit: ' + Utils.getErrorMessage(err), err);
        }
    }

    private onResume() {
        log?.debug('onResume');

        try {
            this.detectChanges('onResume');
        } catch (err) {
            log.error('onResume: ' + Utils.getErrorMessage(err));
        }
    }

    detectChanges(info: string) {
        if (!this.isDestroyed) {
            log?.debug('detectChanges: ' + info);
            this.cdr.detectChanges();
        }
    }

    ngOnDestroy() {
        log?.debug('ngOnDestroy');

        this.subscriptions.forEach(p => p.unsubscribe());
        this.subscriptions = [];

        this.isDestroyed = true;

        this.auftragdetails.dispose();
        this.auftragdetails = null;
    }

    async ionViewWillEnter() {
        log?.debug('ionViewWillEnter');

        if (AppConfig.current.einstellungen.Animationen === 'nein') {
            MyApp.loading(true);
            // App.loadingDelayed(true, 500);
        }
    }

    async ionViewDidEnter() {
        log?.debug('ionViewDidEnter');

        this.isVisible = true;

        MyApp.current.backAction = () => this.goBack();

        let ttl = 20;

        while (!this.auftrag) {
            await MyApp.delay(100);

            if (ttl-- < 0) {
                break;
            }

            if (this.isDestroyed) {
                // Tritt auf, wenn beim Betreten der Auftrag nicht gefunden wird
                // und die Auftragdetails gleich wieder verlasen werden.
                MyApp.loading(false);
                return;
            }
        }

        this.auftragService.setzeAktivenAuftrag(this.auftrag, 'auftragdetails');

        if (this.appLieferung) {
            this.appLieferung.refresh();
        }

        MyApp.loading(false);
        // this.detectChanges('ionViewDidEnter');
    }

    ionViewWillLeave() {
        this.isVisible = false;

        MyApp.current.backAction = null;
        this.auftragService.setzeAktivenAuftrag(null, 'auftragdetails exit');
    }

    async goBack() {
        log?.debug('goBack');

        // TODO
        if (this.auftragdetails.anzeigeBild) {
            log?.debug('goBack abbruch wegen anzeigeBild');
            this.auftragdetails.anzeigeBild = null;
            return;
        }

        if (this.auftragdetails.alertAktiv) {
            log?.debug('goBack abbruch wegen alertAktiv');
            // ignoriere Hardware-Back-Button
            return;
        }

        if (this.auftragdetails.kameraAktiv) {
            log?.debug('goBack abbruch wegen kameraAktiv');
            // ignoriere Hardware-Back-Button
            return;
        }

        if (this.auftrag) {
            if (this.auftrag.OberAuftragKey) {
                await this.nav.navigateBack('/auftragsliste/details/' + this.auftrag.OberAuftragKey);
            } else {
                await this.nav.navigateBack('/auftragsliste/aktuell/' + this.auftrag.Auftragstyp);
            }
        } else {
            await this.nav.navigateRoot('/');
        }
    }

    getTitel(): string {
        if (this.auftrag) {
            if (this.auftrag.Auftragstyp == Auftragstyp.Kommissionierung) {
                if (this.auftrag.OberAuftragKey) {
                    return 'Palette ' + this.auftrag.label;
                } else {
                    return 'Tour ' + this.auftragsnummer;
                }
            }
        }

        let text = this.auftragsnummer + ' Auftrag';

        if (this.unterMandant) {
            text += ', ' + this.unterMandant;
        }

        return text;
    }

    onFotoAufnehmen() {
        this.auftragdetails.onFotoAufnehmen();
    }

    async onOptionenAnzeigen() {
        log?.debug('onOptionenAnzeigen');

        const that = this;

        const buttons: ActionSheetButton[] = [];

        if (this.navigation) {
            buttons.push({
                text: 'Navigation zum Einsatzort', //Übersetzen
                role: 'destructive',
                icon: 'navigate',
                handler: () => {
                    this.auftragdetails.starteNavigation(this.auftrag.Abholadresse);
                }
            });
        }

        if (this.fotos && !this.auftragdetails.isBilderErfassenGesperrt) {
            buttons.push({
                text: 'Foto aufnehmen',
                icon: 'camera',
                handler: () => {
                    this.auftragdetails.onFotoAufnehmen();
                }
            });
        }

        if (this.lieferungAnzeigen && !this.auftragdetails.isLieferungAendernGesperrt) {
            buttons.push({
                text: 'Lieferung ändern',
                icon: 'basket',
                handler: () => {
                    this.auftragdetails.lieferungAendern();
                }
            });
        }

        if (AppConfig.current.einstellungen.AuftragBarcodeButtonVerfuegbar === 'ja') {
            buttons.push({
                text: 'Barcode anzeigen',
                icon: 'barcode',
                handler: () => {
                    this.auftragdetails.anzeigenBarcode();
                }
            });
        }

        buttons.push({
            text: 'Abbruch',
            icon: 'close',
            role: 'cancel',
            handler: () => {
                log?.debug('Cancel clicked');
            }
        });

        const actionSheet = await this.actionSheetController.create({
            header: 'Mehr',
            buttons
        });

        await actionSheet.present();
    }

    async onShowMenu(event: any) {
        log?.debug('onShowMenu', event);

        const popover = await this.popoverController.create({
            component: AuftragMenuPopoverComponent,
            cssClass: 'auftrag-menu',
            event: event,
            translucent: true,
            componentProps: {
                'auftragdetails': this.auftragdetails
            }
        });

        await popover.present();
    }
}